/**
 * Logo RCA afișat lângă numele asiguratorului (SVG/WebP în public/resources/insurers).
 */
const ICON_BY_URL = {
  "https://www.allianztiriac.ro": "/resources/insurers/allianz-tiriac.svg",
  "https://www.asirom.ro": "/resources/insurers/asirom.svg",
  "https://www.axeria-iard.ro/": "/resources/insurers/axeria.svg",
  "https://www.axeria.ro": "/resources/insurers/axeria.svg",
  "https://dallbogg.com/ro/": "/resources/insurers/dallbogg.svg",
  "https://www.eazyinsure.ro/": "/resources/insurers/eazy.svg",
  "https://www.generali.ro": "/resources/insurers/generali.svg",
  "https://www.grawe.ro": "/resources/insurers/grawe.svg",
  "https://www.groupama.ro": "/resources/insurers/groupama.svg",
  "https://www.hellasdirect.ro/": "/resources/insurers/hellas-direct.webp",
  "https://hellasdirect.ro": "/resources/insurers/hellas-direct.webp",
  "https://www.omniasig.ro": "/resources/insurers/omniasig.svg",
};

export function rcaPartnerIconSrc(url) {
  return ICON_BY_URL[url] ?? null;
}
